module.exports = __webpack_public_path__ + "static/media/r44.457a7e22.jpg";